module.exports = __webpack_public_path__ + "img/drug-17.9225f198.png";